// RespiteSupportSection.js
import React from "react";
import respiteSupportImage from "../assets/respite-support-image.jpg";

const RespiteSupportSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Respite Care to Support Both Family Caregivers and Seniors
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed">
              <p>
                Caring for a loved one can be rewarding, but it can also be
                physically and emotionally{" "}
                <span className="text-[#E85D2C] font-normal">demanding</span>.
                At Allawah Lodge, we understand the importance of providing
                compassionate relief and support to both caregivers and seniors
                through our respite care services. Our respite care is designed
                to offer a temporary break for caregivers while ensuring that
                seniors receive the quality care they need in a safe and
                nurturing environment.
              </p>

              <p>
                Our respite care services are delivered by our team of trained
                and compassionate caregivers who specialise in providing
                exceptional care to seniors. During the respite period,
                caregivers can take time for themselves, attend to personal
                matters, or simply recharge, knowing that their loved one is in
                capable and caring hands. To take advantage of our respite care
                services,{" "}
                <a
                  href="/contact"
                  className="text-[#E85D2C] font-normal hover:underline"
                >
                  contact us today
                </a>
                !
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={respiteSupportImage}
              alt="Caregiver with elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RespiteSupportSection;
